import { NotLoggedInMasterComponent } from './layout/not-loggedin/not-loggedin.master';
import { FooterComponent } from './layout/footer/footer.master';
import { MainLayoutEffects } from './layout/main/effects';
import { HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { SMRTRoutingModule } from './smrt-routing.module';
import { featureKey, reducers } from './store/smrt.reducers';
import { MainMasterComponent } from './layout/main/main.master';
import { MaterialModule } from 'src/app/app.material.module';
import { IfaaUiComponentsModule } from '@ifaa-components/ui-components';
import { EmployerPortalSharedModule } from '../shared/shared.module';
import { TenantDashboardComponent } from './views/dashboard/dashboard.component';
import { NgwWowModule } from 'ngx-wow';


@NgModule({
  declarations: [
    MainMasterComponent,
    FooterComponent,
    NotLoggedInMasterComponent,
    TenantDashboardComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    NgwWowModule,
    SMRTRoutingModule,
    HttpClientModule,
    MaterialModule,
    IfaaUiComponentsModule,
    StoreModule.forFeature(featureKey, reducers),
    EffectsModule.forFeature([MainLayoutEffects]),
    EmployerPortalSharedModule,

  ],
  exports: [
    MainMasterComponent,
    NotLoggedInMasterComponent,
    TenantDashboardComponent
  ],
  providers: [
  ]
})
export class SMRTModule { }
